import { takeEvery, put, call, all, fork } from "redux-saga/effects";

import {
  GET_SINGLE_CUSTOMERS_LIST_DATA,
  GET_SINGLE_CUSTOMERS_DATA,
  ADD_NEW_SINGLE_CUSTOMER,
  UPDATE_SINGLE_CUSTOMER,
  DELETE_SINGLE_CUSTOMER,
  CREATE_NEW_SINGLE_CUSTOMER,
  GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA,
  SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA,
  SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA,
  GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA,
  GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA,
  ADD_NEW_SINGLE_CUSTOMER_SITE_LOCATION,
  UPDATE_SINGLE_CUSTOMER_SITE_LOCATION,
  DELETE_SINGLE_CUSTOMER_SITE_LOCATION,
  GET_SINGLE_CUSTOMER_URL_LINK_DETAILS,
  CREATE_SINGLE_CUSTOMER_URL_LINK,
  UPDATE_SINGLE_CUSTOMER_URL_LINK,
  DELETE_SINGLE_CUSTOMER_URL_LINK,
  GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA,
  GET_CUSTOMER_URL_LINK_STATUS_DETAILS,
  CREATE_CUSTOMER_URL_LINK_STATUS,
  UPDATE_CUSTOMER_URL_LINK_STATUS,
  DELETE_CUSTOMER_URL_LINK_STATUS,
  GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA,
  GET_CUSTOMER_URL_LINK_TYPE_DETAILS,
  CREATE_CUSTOMER_URL_LINK_TYPE,
  UPDATE_CUSTOMER_URL_LINK_TYPE,
  DELETE_CUSTOMER_URL_LINK_TYPE,
  GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA,
  GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA,
  GET_CUSTOMERS_BALANCE_LIST_ALL_DATA,
  CLEAR_CUSTOMER_TRANSACTIONS_LIST,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS,
  CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS,
  UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS,
  DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA,
  GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS,
  CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
  UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
  DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
  GET_CUSTOMER_STATUS_LIST_DATA,
  GET_CUSTOMER_STATUS_DETAILS,
  CREATE_CUSTOMER_STATUS,
  UPDATE_CUSTOMER_STATUS,
  DELETE_CUSTOMER_STATUS,
  GET_CUSTOMER_TYPE_LIST_DATA,
  GET_CUSTOMER_TYPE_DETAILS,
  CREATE_CUSTOMER_TYPE,
  UPDATE_CUSTOMER_TYPE,
  DELETE_CUSTOMER_TYPE,
  EXPORT_CONTACTS,
  SEARCH_CUSTOMER,
  GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES,
  GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE,
  GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER,
  SEARCH_CUSTOMER_NOTE,
  CREATE_CUSTOMER_NOTE,
} from "./actionType";

import {
  getCustomersListDataSuccess,
  getCustomersListDataFail,
  getSingleCustomersDataSuccess,
  getSingleCustomersDataFail,
  addSingleCustomerSuccess,
  addSingleCustomerFail,
  updateSingleCustomerSuccess,
  updateSingleCustomerFail,
  deleteSingleCustomerSuccess,
  deleteSingleCustomerFail,
  createSingleCustomerSuccess,
  createSingleCustomerFail,
  getSingleCustomerActivitiesListDataSuccess,
  getSingleCustomerActivitiesListDataFail,
  searchSingleCustomerURLLinkListDataSuccess,
  searchSingleCustomerURLLinkListDataFail,
  searchSingleCustomerExternalIDsListDataSuccess,
  searchSingleCustomerExternalIDsListDataFail,
  getSingleCustomerSiteLocationListDataSuccess,
  getSingleCustomerSiteLocationListDataFail,
  getSingleCustomerSiteLocationDataSuccess,
  getSingleCustomerSiteLocationDataFail,
  addSingleCustomerSiteLocationSuccess,
  addSingleCustomerSiteLocationFail,
  updateSingleCustomerSiteLocationSuccess,
  updateSingleCustomerSiteLocationFail,
  deleteSingleCustomerSiteLocationSuccess,
  deleteSingleCustomerSiteLocationFail,
  getSingleCustomerURLLinkDetailsSuccess,
  getSingleCustomerURLLinkDetailsFail,
  createSingleCustomerURLLinkSuccess,
  createSingleCustomerURLLinkFail,
  updateSingleCustomerURLLinkSuccess,
  updateSingleCustomerURLLinkFail,
  deleteSingleCustomerURLLinkSuccess,
  deleteSingleCustomerURLLinkFail,
  getCustomerURLLinkStatusListDataSuccess,
  getCustomerURLLinkStatusListDataFail,
  getCustomerURLLinkStatusDetailsSuccess,
  getCustomerURLLinkStatusDetailsFail,
  createCustomerURLLinkStatusSuccess,
  createCustomerURLLinkStatusFail,
  updateCustomerURLLinkStatusSuccess,
  updateCustomerURLLinkStatusFail,
  deleteCustomerURLLinkStatusSuccess,
  deleteCustomerURLLinkStatusFail,
  getCustomerURLLinkTypeListDataSuccess,
  getCustomerURLLinkTypeListDataFail,
  getCustomerURLLinkTypeDetailsSuccess,
  getCustomerURLLinkTypeDetailsFail,
  createCustomerURLLinkTypeSuccess,
  createCustomerURLLinkTypeFail,
  updateCustomerURLLinkTypeSuccess,
  updateCustomerURLLinkTypeFail,
  deleteCustomerURLLinkTypeSuccess,
  deleteCustomerURLLinkTypeFail,
  getCustomersDebitBalanceListDataSuccess,
  getCustomersDebitBalanceListDataFail,
  getCustomersOverdueBalanceListDataSuccess,
  getCustomersOverdueBalanceListDataFail,
  getCustomersBalanceListAllDataSuccess,
  getCustomersBalanceListAllDataFail,
  clearCustomerTransactionsListSuccess,
  clearCustomerTransactionsListFail,
  getSingleCustomerExternalIDsDetailsSuccess,
  getSingleCustomerExternalIDsDetailsFail,
  createSingleCustomerExternalIDsSuccess,
  createSingleCustomerExternalIDsFail,
  updateSingleCustomerExternalIDsSuccess,
  updateSingleCustomerExternalIDsFail,
  deleteSingleCustomerExternalIDsSuccess,
  deleteSingleCustomerExternalIDsFail,
  getSingleCustomerExternalIDsExternalIdentificationProviderListDataSuccess,
  getSingleCustomerExternalIDsExternalIdentificationProviderListDataFail,
  getSingleCustomerExternalIDsExternalIdentificationProviderDetailsSuccess,
  getSingleCustomerExternalIDsExternalIdentificationProviderDetailsFail,
  createSingleCustomerExternalIDsExternalIdentificationProviderSuccess,
  createSingleCustomerExternalIDsExternalIdentificationProviderFail,
  updateSingleCustomerExternalIDsExternalIdentificationProviderSuccess,
  updateSingleCustomerExternalIDsExternalIdentificationProviderFail,
  deleteSingleCustomerExternalIDsExternalIdentificationProviderSuccess,
  deleteSingleCustomerExternalIDsExternalIdentificationProviderFail,
  getCustomerStatusListDataSuccess,
  getCustomerStatusListDataFail,
  getCustomerStatusDetailsSuccess,
  getCustomerStatusDetailsFail,
  createCustomerStatusSuccess,
  createCustomerStatusFail,
  updateCustomerStatusSuccess,
  updateCustomerStatusFail,
  deleteCustomerStatusSuccess,
  deleteCustomerStatusFail,
  getCustomerTypeListDataSuccess,
  getCustomerTypeListDataFail,
  getCustomerTypeDetailsSuccess,
  getCustomerTypeDetailsFail,
  createCustomerTypeSuccess,
  createCustomerTypeFail,
  updateCustomerTypeSuccess,
  updateCustomerTypeFail,
  deleteCustomerTypeSuccess,
  deleteCustomerTypeFail,
  exportContactsSuccess,
  exportContactsFail,
  searchCustomerSuccess,
  searchCustomerFail,
  getCustomerBalanceHistoricalAvailableDatesSuccess,
  getCustomerBalanceHistoricalAvailableDatesFail,
  getCustomerBalanceHistoricalSpecificDateSuccess,
  getCustomerBalanceHistoricalSpecificDateFail,
  getCustomerBalanceHistoricalByCustomerSuccess,
  getCustomerBalanceHistoricalByCustomerFail,
  searchCustomerNoteSuccess,
  searchCustomerNoteFail,
  createCustomerNoteSuccess,
  createCustomerNoteFail,
} from "./action";

// get api call for customers list

import {
  getCustomerList,
  getCustomerSingleData,
  addSingleCustomer,
  updateSingleCustomer,
  deleteSingleCustomer,
  createNewSingleCustomerApiCall,
  getSingleCustomerActivitiesListApiCall,
  searchSingleCustomerURLLinkListApiCall,
  searchSingleCustomerExternalIDsListApiCall,
  getSingleCustomerSiteLocationListApiCall,
  getSingleCustomerSiteLocationDataApiCall,
  addSingleCustomerSiteLocationApiCall,
  updateSingleCustomerSiteLocationApiCall,
  deleteSingleCustomerSiteLocationApiCall,
  getSingleCustomerURLLinkDetailsApiCall,
  createSingleCustomerURLLinkApiCall,
  updateSingleCustomerURLLinkApiCall,
  deleteSingleCustomerURLLinkApiCall,
  getCustomerURLLinkStatusListApiCall,
  getCustomerURLLinkStatusDetailsApiCall,
  createCustomerURLLinkStatusApiCall,
  updateCustomerURLLinkStatusApiCall,
  deleteCustomerURLLinkStatusApiCall,
  getCustomerURLLinkTypeListApiCall,
  getCustomerURLLinkTypeDetailsApiCall,
  createCustomerURLLinkTypeApiCall,
  updateCustomerURLLinkTypeApiCall,
  deleteCustomerURLLinkTypeApiCall,
  getCustomersDebitBalanceListApiCall,
  getCustomersOverdueBalanceListApiCall,
  getCustomersBalanceListAllApiCall,
  clearCustomerTransactionsListApiCall,
  getSingleCustomerExternalIDsDetailsApiCall,
  createSingleCustomerExternalIDsApiCall,
  updateSingleCustomerExternalIDsApiCall,
  deleteSingleCustomerExternalIDsApiCall,
  getSingleCustomerExternalIDsExternalIdentificationProviderListApiCall,
  getSingleCustomerExternalIDsExternalIdentificationProviderDetailsApiCall,
  createSingleCustomerExternalIDsExternalIdentificationProviderApiCall,
  updateSingleCustomerExternalIDsExternalIdentificationProviderApiCall,
  deleteSingleCustomerExternalIDsExternalIdentificationProviderApiCall,
  getCustomerStatusListDataApiCall,
  getCustomerStatusDetailsApiCall,
  createCustomerStatusApiCall,
  updateCustomerStatusApiCall,
  deleteCustomerStatusApiCall,
  getCustomerTypeListDataApiCall,
  getCustomerTypeDetailsApiCall,
  createCustomerTypeApiCall,
  updateCustomerTypeApiCall,
  deleteCustomerTypeApiCall,
  exportContactsApiCall,
  searchCustomerApiCall,
  getCustomerBalanceHistoricalAvailableDatesApiCall,
  getCustomerBalanceHistoricalSpecificDateApiCall,
  getCustomerBalanceHistoricalByCustomerApiCall,
  searchCustomerNoteApiCall,
  createCustomerNoteApiCall,
} from "../../helpers/fakebackend_helper";

// ****** Customer List Saga ******
export function* getCustomersListDataSaga() {
  const response = yield call(getCustomerList);
  if (response) {
    yield put(getCustomersListDataSuccess(response));
  } else {
    yield put(getCustomersListDataFail(response));
  }
}

export function* watchGetCustomersListDataSaga() {
  yield takeEvery(GET_SINGLE_CUSTOMERS_LIST_DATA, getCustomersListDataSaga);
}

// ****** Customer Saga ******

export function* getSingleCustomersDataSaga(action) {
  const response = yield call(getCustomerSingleData, action.payload);
  if (response) {
    yield put(getSingleCustomersDataSuccess(response));
  } else {
    yield put(getSingleCustomersDataFail(response));
  }
}

export function* watchGetSingleCustomersDataSaga() {
  yield takeEvery(GET_SINGLE_CUSTOMERS_DATA, getSingleCustomersDataSaga);
}

// ****** Create New Customer Saga ******
export function* addSingleNewCustomerSaga(action) {
  const response = yield call(addSingleCustomer, action.payload);
  if (response) {
    yield put(addSingleCustomerSuccess(response));
  } else {
    yield put(addSingleCustomerFail(response));
  }
}

export function* watchAddSingleNewCustomerSaga() {
  yield takeEvery(ADD_NEW_SINGLE_CUSTOMER, addSingleNewCustomerSaga);
}

// ****** Update Customer Saga ******

export function* updateSingleCustomerSaga(action) {
  const response = yield call(updateSingleCustomer, action.payload);
  if (response) {
    yield put(updateSingleCustomerSuccess(response));
  } else {
    yield put(updateSingleCustomerFail(response));
  }
}

export function* watchUpdateSingleCustomerSaga() {
  yield takeEvery(UPDATE_SINGLE_CUSTOMER, updateSingleCustomerSaga);
}

// ****** Delete Customer Saga ******
export function* deleteSingleCustomerSaga(action) {
  const response = yield call(deleteSingleCustomer, action.payload);
  if (response) {
    yield put(deleteSingleCustomerSuccess(response));
  } else {
    yield put(deleteSingleCustomerFail(response));
  }
}

export function* watchDeleteSingleCustomerSaga() {
  yield takeEvery(DELETE_SINGLE_CUSTOMER, deleteSingleCustomerSaga);
}
// Create New Single Customer API

export function* createNewSingleCustomerSaga(action) {
  const response = yield call(createNewSingleCustomerApiCall, action.payload);
  if (response) {
    yield put(createSingleCustomerSuccess(response));
  } else {
    yield put(createSingleCustomerFail(response));
  }
}

export function* watchCreateNewSingleCustomerSaga() {
  yield takeEvery(CREATE_NEW_SINGLE_CUSTOMER, createNewSingleCustomerSaga);
}

// Get Single Customer Activities List Data

export function* getSingleCustomerActivitiesListDataSaga(action) {
  const response = yield call(
    getSingleCustomerActivitiesListApiCall,
    action.payload
  );
  if (response) {
    yield put(getSingleCustomerActivitiesListDataSuccess(response));
  } else {
    yield put(getSingleCustomerActivitiesListDataFail(response));
  }
}

export function* watchGetSingleCustomerActivitiesListDataSaga() {
  yield takeEvery(
    GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA,
    getSingleCustomerActivitiesListDataSaga
  );
}
// Search Single Customer URL Link List Data

export function* searchSingleCustomerURLLinkListDataSaga(action) {
  const response = yield call(
    searchSingleCustomerURLLinkListApiCall,
    action.payload
  );
  if (response) {
    yield put(searchSingleCustomerURLLinkListDataSuccess(response));
  } else {
    yield put(searchSingleCustomerURLLinkListDataFail(response));
  }
}

export function* watchSearchSingleCustomerURLLinkListDataSaga() {
  yield takeEvery(
    SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA,
    searchSingleCustomerURLLinkListDataSaga
  );
}
// Search Single Customer External IDs List Data

export function* searchSingleCustomerExternalIDsListDataSaga(action) {
  const response = yield call(
    searchSingleCustomerExternalIDsListApiCall,
    action.payload
  );
  if (response) {
    yield put(searchSingleCustomerExternalIDsListDataSuccess(response));
  } else {
    yield put(searchSingleCustomerExternalIDsListDataFail(response));
  }
}

export function* watchSearchSingleCustomerExternalIDsListDataSaga() {
  yield takeEvery(
    SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA,
    searchSingleCustomerExternalIDsListDataSaga
  );
}

// ****** Customer Site Location List Saga ******
export function* getSingleCustomerSiteLocationListDataSaga(action) {
  const response = yield call(
    getSingleCustomerSiteLocationListApiCall,
    action.payload
  );
  if (response) {
    yield put(getSingleCustomerSiteLocationListDataSuccess(response));
  } else {
    yield put(getSingleCustomerSiteLocationListDataFail(response));
  }
}

export function* watchGetSingleCustomerSiteLocationListDataSaga() {
  yield takeEvery(
    GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA,
    getSingleCustomerSiteLocationListDataSaga
  );
}

// Get Single Customer Site Location Data

export function* getSingleCustomerSiteLocationDataSaga(action) {
  const response = yield call(
    getSingleCustomerSiteLocationDataApiCall,
    action.payload
  );
  if (response) {
    yield put(getSingleCustomerSiteLocationDataSuccess(response));
  } else {
    yield put(getSingleCustomerSiteLocationDataFail(response));
  }
}

export function* watchGetSingleCustomerSiteLocationDataSaga() {
  yield takeEvery(
    GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA,
    getSingleCustomerSiteLocationDataSaga
  );
}

//  Add New Single Customer Site Location API

export function* addNewSingleCustomerSiteLocationSaga(action) {
  try {
    const response = yield call(
      addSingleCustomerSiteLocationApiCall,
      action.payload
    );

    yield put(addSingleCustomerSiteLocationSuccess(response));
  } catch (error) {
    yield put(addSingleCustomerSiteLocationFail(error));
  }
}

export function* watchAddNewSingleCustomerSiteLocationSaga() {
  yield takeEvery(
    ADD_NEW_SINGLE_CUSTOMER_SITE_LOCATION,
    addNewSingleCustomerSiteLocationSaga
  );
}

// Update Single Customer Site Location API

export function* updateSingleCustomerSiteLocationSaga(action) {
  const response = yield call(
    updateSingleCustomerSiteLocationApiCall,
    action.payload
  );
  if (response) {
    yield put(updateSingleCustomerSiteLocationSuccess(response));
  } else {
    yield put(updateSingleCustomerSiteLocationFail(response));
  }
}

export function* watchUpdateSingleCustomerSiteLocationSaga() {
  yield takeEvery(
    UPDATE_SINGLE_CUSTOMER_SITE_LOCATION,
    updateSingleCustomerSiteLocationSaga
  );
}

// Delete Single Customer Site Location API

export function* deleteSingleCustomerSiteLocationSaga(action) {
  const response = yield call(
    deleteSingleCustomerSiteLocationApiCall,
    action.payload
  );
  if (response) {
    yield put(deleteSingleCustomerSiteLocationSuccess(response));
  } else {
    yield put(deleteSingleCustomerSiteLocationFail(response));
  }
}

export function* watchDeleteSingleCustomerSiteLocationSaga() {
  yield takeEvery(
    DELETE_SINGLE_CUSTOMER_SITE_LOCATION,
    deleteSingleCustomerSiteLocationSaga
  );
}

// Get Single Customer URL Link Details

export function* getSingleCustomerURLLinkDetailsSaga(action) {
  const response = yield call(
    getSingleCustomerURLLinkDetailsApiCall,
    action.payload
  );
  if (response) {
    yield put(getSingleCustomerURLLinkDetailsSuccess(response));
  } else {
    yield put(getSingleCustomerURLLinkDetailsFail(response));
  }
}

export function* watchGetSingleCustomerURLLinkDetailsSaga() {
  yield takeEvery(
    GET_SINGLE_CUSTOMER_URL_LINK_DETAILS,
    getSingleCustomerURLLinkDetailsSaga
  );
}

// Create Single Customer URL Link API

export function* createSingleCustomerURLLinkSaga(action) {
  const response = yield call(
    createSingleCustomerURLLinkApiCall,
    action.payload
  );
  if (response) {
    yield put(createSingleCustomerURLLinkSuccess(response));
  } else {
    yield put(createSingleCustomerURLLinkFail(response));
  }
}

export function* watchCreateSingleCustomerURLLinkSaga() {
  yield takeEvery(
    CREATE_SINGLE_CUSTOMER_URL_LINK,
    createSingleCustomerURLLinkSaga
  );
}

// Update Single Customer URL Link API

export function* updateSingleCustomerURLLinkSaga(action) {
  const response = yield call(
    updateSingleCustomerURLLinkApiCall,
    action.payload
  );
  if (response) {
    yield put(updateSingleCustomerURLLinkSuccess(response));
  } else {
    yield put(updateSingleCustomerURLLinkFail(response));
  }
}

export function* watchUpdateSingleCustomerURLLinkSaga() {
  yield takeEvery(
    UPDATE_SINGLE_CUSTOMER_URL_LINK,
    updateSingleCustomerURLLinkSaga
  );
}

// Delete Single Customer URL Link API

export function* deleteSingleCustomerURLLinkSaga(action) {
  const response = yield call(
    deleteSingleCustomerURLLinkApiCall,
    action.payload
  );
  if (response) {
    yield put(deleteSingleCustomerURLLinkSuccess(response));
  } else {
    yield put(deleteSingleCustomerURLLinkFail(response));
  }
}

export function* watchDeleteSingleCustomerURLLinkSaga() {
  yield takeEvery(
    DELETE_SINGLE_CUSTOMER_URL_LINK,
    deleteSingleCustomerURLLinkSaga
  );
}

// Get Customer URL Link Status List Data

export function* getCustomerURLLinkStatusListDataSaga(action) {
  const response = yield call(
    getCustomerURLLinkStatusListApiCall,
    action.payload
  );
  if (response) {
    yield put(getCustomerURLLinkStatusListDataSuccess(response));
  } else {
    yield put(getCustomerURLLinkStatusListDataFail(response));
  }
}

export function* watchGetCustomerURLLinkStatusListDataSaga() {
  yield takeEvery(
    GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA,
    getCustomerURLLinkStatusListDataSaga
  );
}

// Get Customer URL Link Status Details

export function* getCustomerURLLinkStatusDetailsSaga(action) {
  const response = yield call(
    getCustomerURLLinkStatusDetailsApiCall,
    action.payload
  );
  if (response) {
    yield put(getCustomerURLLinkStatusDetailsSuccess(response));
  } else {
    yield put(getCustomerURLLinkStatusDetailsFail(response));
  }
}

export function* watchGetCustomerURLLinkStatusDetailsSaga() {
  yield takeEvery(
    GET_CUSTOMER_URL_LINK_STATUS_DETAILS,
    getCustomerURLLinkStatusDetailsSaga
  );
}

// Create Customer URL Link Status API

export function* createCustomerURLLinkStatusSaga(action) {
  const response = yield call(
    createCustomerURLLinkStatusApiCall,
    action.payload
  );
  if (response) {
    yield put(createCustomerURLLinkStatusSuccess(response));
  } else {
    yield put(createCustomerURLLinkStatusFail(response));
  }
}

export function* watchCreateCustomerURLLinkStatusSaga() {
  yield takeEvery(
    CREATE_CUSTOMER_URL_LINK_STATUS,
    createCustomerURLLinkStatusSaga
  );
}

// Update Customer URL Link Status API

export function* updateCustomerURLLinkStatusSaga(action) {
  const response = yield call(
    updateCustomerURLLinkStatusApiCall,
    action.payload
  );
  if (response) {
    yield put(updateCustomerURLLinkStatusSuccess(response));
  } else {
    yield put(updateCustomerURLLinkStatusFail(response));
  }
}

export function* watchUpdateCustomerURLLinkStatusSaga() {
  yield takeEvery(
    UPDATE_CUSTOMER_URL_LINK_STATUS,
    updateCustomerURLLinkStatusSaga
  );
}

// Delete Customer URL Link Status API

export function* deleteCustomerURLLinkStatusSaga(action) {
  const response = yield call(
    deleteCustomerURLLinkStatusApiCall,
    action.payload
  );
  if (response) {
    yield put(deleteCustomerURLLinkStatusSuccess(response));
  } else {
    yield put(deleteCustomerURLLinkStatusFail(response));
  }
}

export function* watchDeleteCustomerURLLinkStatusSaga() {
  yield takeEvery(
    DELETE_CUSTOMER_URL_LINK_STATUS,
    deleteCustomerURLLinkStatusSaga
  );
}

// Get Customer URL Link Type List Data

export function* getCustomerURLLinkTypeListDataSaga(action) {
  const response = yield call(
    getCustomerURLLinkTypeListApiCall,
    action.payload
  );
  if (response) {
    yield put(getCustomerURLLinkTypeListDataSuccess(response));
  } else {
    yield put(getCustomerURLLinkTypeListDataFail(response));
  }
}

export function* watchGetCustomerURLLinkTypeListDataSaga() {
  yield takeEvery(
    GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA,
    getCustomerURLLinkTypeListDataSaga
  );
}

// Get Customer URL Link Type Details

export function* getCustomerURLLinkTypeDetailsSaga(action) {
  const response = yield call(
    getCustomerURLLinkTypeDetailsApiCall,
    action.payload
  );
  if (response) {
    yield put(getCustomerURLLinkTypeDetailsSuccess(response));
  } else {
    yield put(getCustomerURLLinkTypeDetailsFail(response));
  }
}

export function* watchGetCustomerURLLinkTypeDetailsSaga() {
  yield takeEvery(
    GET_CUSTOMER_URL_LINK_TYPE_DETAILS,
    getCustomerURLLinkTypeDetailsSaga
  );
}

// Create Customer URL Link Type API

export function* createCustomerURLLinkTypeSaga(action) {
  const response = yield call(createCustomerURLLinkTypeApiCall, action.payload);
  if (response) {
    yield put(createCustomerURLLinkTypeSuccess(response));
  } else {
    yield put(createCustomerURLLinkTypeFail(response));
  }
}

export function* watchCreateCustomerURLLinkTypeSaga() {
  yield takeEvery(CREATE_CUSTOMER_URL_LINK_TYPE, createCustomerURLLinkTypeSaga);
}

// Update Customer URL Link Type API

export function* updateCustomerURLLinkTypeSaga(action) {
  const response = yield call(updateCustomerURLLinkTypeApiCall, action.payload);
  if (response) {
    yield put(updateCustomerURLLinkTypeSuccess(response));
  } else {
    yield put(updateCustomerURLLinkTypeFail(response));
  }
}

export function* watchUpdateCustomerURLLinkTypeSaga() {
  yield takeEvery(UPDATE_CUSTOMER_URL_LINK_TYPE, updateCustomerURLLinkTypeSaga);
}

// Delete Customer URL Link Type API

export function* deleteCustomerURLLinkTypeSaga(action) {
  const response = yield call(deleteCustomerURLLinkTypeApiCall, action.payload);
  if (response) {
    yield put(deleteCustomerURLLinkTypeSuccess(response));
  } else {
    yield put(deleteCustomerURLLinkTypeFail(response));
  }
}

export function* watchDeleteCustomerURLLinkTypeSaga() {
  yield takeEvery(DELETE_CUSTOMER_URL_LINK_TYPE, deleteCustomerURLLinkTypeSaga);
}

// Get Customers Debit Balance List Data

export function* getCustomersDebitBalanceListDataSaga() {
  const response = yield call(getCustomersDebitBalanceListApiCall);
  if (response) {
    yield put(getCustomersDebitBalanceListDataSuccess(response));
  } else {
    yield put(getCustomersDebitBalanceListDataFail(response));
  }
}

export function* watchGetCustomersDebitBalanceListDataSaga() {
  yield takeEvery(
    GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA,
    getCustomersDebitBalanceListDataSaga
  );
}

// Get Customers Overdue Balance List Data

export function* getCustomersOverdueBalanceListDataSaga() {
  const response = yield call(getCustomersOverdueBalanceListApiCall);
  if (response) {
    yield put(getCustomersOverdueBalanceListDataSuccess(response));
  } else {
    yield put(getCustomersOverdueBalanceListDataFail(response));
  }
}

export function* watchGetCustomersOverdueBalanceListDataSaga() {
  yield takeEvery(
    GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA,
    getCustomersOverdueBalanceListDataSaga
  );
}

// Get Customers Balance List All Data

export function* getCustomersBalanceListAllDataSaga() {
  const response = yield call(getCustomersBalanceListAllApiCall);
  if (response) {
    yield put(getCustomersBalanceListAllDataSuccess(response));
  } else {
    yield put(getCustomersBalanceListAllDataFail(response));
  }
}

export function* watchGetCustomersBalanceListAllDataSaga() {
  yield takeEvery(
    GET_CUSTOMERS_BALANCE_LIST_ALL_DATA,
    getCustomersBalanceListAllDataSaga
  );
}

// Clear Customer Transactions List

export function* clearCustomerTransactionsListSaga({ payload }) {
  const response = yield call(clearCustomerTransactionsListApiCall, payload);
  if (response) {
    yield put(clearCustomerTransactionsListSuccess(response));
  } else {
    yield put(clearCustomerTransactionsListFail(response));
  }
}

export function* watchClearCustomerTransactionsListSaga() {
  yield takeEvery(
    CLEAR_CUSTOMER_TRANSACTIONS_LIST,
    clearCustomerTransactionsListSaga
  );
}

// Get Single Customer External IDs Details

export function* getSingleCustomerExternalIDsDetailsSaga(action) {
  const response = yield call(
    getSingleCustomerExternalIDsDetailsApiCall,
    action.payload
  );
  if (response) {
    yield put(getSingleCustomerExternalIDsDetailsSuccess(response));
  } else {
    yield put(getSingleCustomerExternalIDsDetailsFail(response));
  }
}

export function* watchGetSingleCustomerExternalIDsDetailsSaga() {
  yield takeEvery(
    GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS,
    getSingleCustomerExternalIDsDetailsSaga
  );
}

// Create Single Customer External IDs API

export function* createSingleCustomerExternalIDsSaga(action) {
  const response = yield call(
    createSingleCustomerExternalIDsApiCall,
    action.payload
  );
  if (response) {
    yield put(createSingleCustomerExternalIDsSuccess(response));
  } else {
    yield put(createSingleCustomerExternalIDsFail(response));
  }
}

export function* watchCreateSingleCustomerExternalIDsSaga() {
  yield takeEvery(
    CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS,
    createSingleCustomerExternalIDsSaga
  );
}

// Update Single Customer External IDs API

export function* updateSingleCustomerExternalIDsSaga(action) {
  const response = yield call(
    updateSingleCustomerExternalIDsApiCall,
    action.payload
  );
  if (response) {
    yield put(updateSingleCustomerExternalIDsSuccess(response));
  } else {
    yield put(updateSingleCustomerExternalIDsFail(response));
  }
}

export function* watchUpdateSingleCustomerExternalIDsSaga() {
  yield takeEvery(
    UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS,
    updateSingleCustomerExternalIDsSaga
  );
}

// Delete Single Customer External IDs API

export function* deleteSingleCustomerExternalIDsSaga(action) {
  const response = yield call(
    deleteSingleCustomerExternalIDsApiCall,
    action.payload
  );
  if (response) {
    yield put(deleteSingleCustomerExternalIDsSuccess(response));
  } else {
    yield put(deleteSingleCustomerExternalIDsFail(response));
  }
}

export function* watchDeleteSingleCustomerExternalIDsSaga() {
  yield takeEvery(
    DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS,
    deleteSingleCustomerExternalIDsSaga
  );
}

// Get Single Customer External IDs External Identification Provider List Data

export function* getSingleCustomerExternalIDsExternalIdentificationProviderListDataSaga(
  action
) {
  const response = yield call(
    getSingleCustomerExternalIDsExternalIdentificationProviderListApiCall,
    action.payload
  );
  if (response) {
    yield put(
      getSingleCustomerExternalIDsExternalIdentificationProviderListDataSuccess(
        response
      )
    );
  } else {
    yield put(
      getSingleCustomerExternalIDsExternalIdentificationProviderListDataFail(
        response
      )
    );
  }
}

export function* watchGetSingleCustomerExternalIDsExternalIdentificationProviderListDataSaga() {
  yield takeEvery(
    GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA,
    getSingleCustomerExternalIDsExternalIdentificationProviderListDataSaga
  );
}

// Get Single Customer External IDs External Identification Provider Details

export function* getSingleCustomerExternalIDsExternalIdentificationProviderDetailsSaga(
  action
) {
  const response = yield call(
    getSingleCustomerExternalIDsExternalIdentificationProviderDetailsApiCall,
    action.payload
  );
  if (response) {
    yield put(
      getSingleCustomerExternalIDsExternalIdentificationProviderDetailsSuccess(
        response
      )
    );
  } else {
    yield put(
      getSingleCustomerExternalIDsExternalIdentificationProviderDetailsFail(
        response
      )
    );
  }
}

export function* watchGetSingleCustomerExternalIDsExternalIdentificationProviderDetailsSaga() {
  yield takeEvery(
    GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS,
    getSingleCustomerExternalIDsExternalIdentificationProviderDetailsSaga
  );
}

// Create Single Customer External IDs External Identification Provider API

export function* createSingleCustomerExternalIDsExternalIdentificationProviderSaga(
  action
) {
  const response = yield call(
    createSingleCustomerExternalIDsExternalIdentificationProviderApiCall,
    action.payload
  );
  if (response) {
    yield put(
      createSingleCustomerExternalIDsExternalIdentificationProviderSuccess(
        response
      )
    );
  } else {
    yield put(
      createSingleCustomerExternalIDsExternalIdentificationProviderFail(
        response
      )
    );
  }
}

export function* watchCreateSingleCustomerExternalIDsExternalIdentificationProviderSaga() {
  yield takeEvery(
    CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
    createSingleCustomerExternalIDsExternalIdentificationProviderSaga
  );
}

// Update Single Customer External IDs External Identification Provider API

export function* updateSingleCustomerExternalIDsExternalIdentificationProviderSaga(
  action
) {
  const response = yield call(
    updateSingleCustomerExternalIDsExternalIdentificationProviderApiCall,
    action.payload
  );
  if (response) {
    yield put(
      updateSingleCustomerExternalIDsExternalIdentificationProviderSuccess(
        response
      )
    );
  } else {
    yield put(
      updateSingleCustomerExternalIDsExternalIdentificationProviderFail(
        response
      )
    );
  }
}

export function* watchUpdateSingleCustomerExternalIDsExternalIdentificationProviderSaga() {
  yield takeEvery(
    UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
    updateSingleCustomerExternalIDsExternalIdentificationProviderSaga
  );
}

// Delete Single Customer External IDs External Identification Provider API

export function* deleteSingleCustomerExternalIDsExternalIdentificationProviderSaga(
  action
) {
  const response = yield call(
    deleteSingleCustomerExternalIDsExternalIdentificationProviderApiCall,
    action.payload
  );
  if (response) {
    yield put(
      deleteSingleCustomerExternalIDsExternalIdentificationProviderSuccess(
        response
      )
    );
  } else {
    yield put(
      deleteSingleCustomerExternalIDsExternalIdentificationProviderFail(
        response
      )
    );
  }
}

export function* watchDeleteSingleCustomerExternalIDsExternalIdentificationProviderSaga() {
  yield takeEvery(
    DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER,
    deleteSingleCustomerExternalIDsExternalIdentificationProviderSaga
  );
}

// Get Customer Status List Data

export function* getCustomerStatusListDataSaga() {
  const response = yield call(getCustomerStatusListDataApiCall);
  if (response) {
    yield put(getCustomerStatusListDataSuccess(response));
  } else {
    yield put(getCustomerStatusListDataFail(response));
  }
}

export function* watchGetCustomerStatusListDataSaga() {
  yield takeEvery(GET_CUSTOMER_STATUS_LIST_DATA, getCustomerStatusListDataSaga);
}

// Get Customer Status Details

export function* getCustomerStatusDetailsSaga(action) {
  const response = yield call(getCustomerStatusDetailsApiCall, action.payload);
  if (response) {
    yield put(getCustomerStatusDetailsSuccess(response));
  } else {
    yield put(getCustomerStatusDetailsFail(response));
  }
}

export function* watchGetCustomerStatusDetailsSaga() {
  yield takeEvery(GET_CUSTOMER_STATUS_DETAILS, getCustomerStatusDetailsSaga);
}

// Create Customer Status API

export function* createCustomerStatusSaga(action) {
  const response = yield call(createCustomerStatusApiCall, action.payload);
  if (response) {
    yield put(createCustomerStatusSuccess(response));
  } else {
    yield put(createCustomerStatusFail(response));
  }
}

export function* watchCreateCustomerStatusSaga() {
  yield takeEvery(CREATE_CUSTOMER_STATUS, createCustomerStatusSaga);
}

// Update Customer Status API

export function* updateCustomerStatusSaga(action) {
  const response = yield call(updateCustomerStatusApiCall, action.payload);
  if (response) {
    yield put(updateCustomerStatusSuccess(response));
  } else {
    yield put(updateCustomerStatusFail(response));
  }
}

export function* watchUpdateCustomerStatusSaga() {
  yield takeEvery(UPDATE_CUSTOMER_STATUS, updateCustomerStatusSaga);
}

// Delete Customer Status API

export function* deleteCustomerStatusSaga(action) {
  const response = yield call(deleteCustomerStatusApiCall, action.payload);
  if (response) {
    yield put(deleteCustomerStatusSuccess(response));
  } else {
    yield put(deleteCustomerStatusFail(response));
  }
}

export function* watchDeleteCustomerStatusSaga() {
  yield takeEvery(DELETE_CUSTOMER_STATUS, deleteCustomerStatusSaga);
}

// Get Customer Type List Data

export function* getCustomerTypeListDataSaga() {
  const response = yield call(getCustomerTypeListDataApiCall);
  if (response) {
    yield put(getCustomerTypeListDataSuccess(response));
  } else {
    yield put(getCustomerTypeListDataFail(response));
  }
}

export function* watchGetCustomerTypeListDataSaga() {
  yield takeEvery(GET_CUSTOMER_TYPE_LIST_DATA, getCustomerTypeListDataSaga);
}

// Get Customer Type Details

export function* getCustomerTypeDetailsSaga(action) {
  const response = yield call(getCustomerTypeDetailsApiCall, action.payload);
  if (response) {
    yield put(getCustomerTypeDetailsSuccess(response));
  } else {
    yield put(getCustomerTypeDetailsFail(response));
  }
}

export function* watchGetCustomerTypeDetailsSaga() {
  yield takeEvery(GET_CUSTOMER_TYPE_DETAILS, getCustomerTypeDetailsSaga);
}

// Create Customer Type API

export function* createCustomerTypeSaga(action) {
  const response = yield call(createCustomerTypeApiCall, action.payload);
  if (response) {
    yield put(createCustomerTypeSuccess(response));
  } else {
    yield put(createCustomerTypeFail(response));
  }
}

export function* watchCreateCustomerTypeSaga() {
  yield takeEvery(CREATE_CUSTOMER_TYPE, createCustomerTypeSaga);
}

// Update Customer Type API

export function* updateCustomerTypeSaga(action) {
  const response = yield call(updateCustomerTypeApiCall, action.payload);
  if (response) {
    yield put(updateCustomerTypeSuccess(response));
  } else {
    yield put(updateCustomerTypeFail(response));
  }
}

export function* watchUpdateCustomerTypeSaga() {
  yield takeEvery(UPDATE_CUSTOMER_TYPE, updateCustomerTypeSaga);
}

// Delete Customer Type API

export function* deleteCustomerTypeSaga(action) {
  const response = yield call(deleteCustomerTypeApiCall, action.payload);
  if (response) {
    yield put(deleteCustomerTypeSuccess(response));
  } else {
    yield put(deleteCustomerTypeFail(response));
  }
}

export function* watchDeleteCustomerTypeSaga() {
  yield takeEvery(DELETE_CUSTOMER_TYPE, deleteCustomerTypeSaga);
}

// Export Contacts

export function* exportContactsSaga(action) {
  const response = yield call(exportContactsApiCall, action.payload);
  if (response) {
    yield put(exportContactsSuccess(response));
  } else {
    yield put(exportContactsFail(response));
  }
}

export function* watchExportContactsSaga() {
  yield takeEvery(EXPORT_CONTACTS, exportContactsSaga);
}
// Search Customer
export function* searchCustomerSaga(action) {
  console.log("action.payload", action.payload);
  const response = yield call(searchCustomerApiCall, action.payload);
  if (response) {
    yield put(searchCustomerSuccess(response));
  } else {
    yield put(searchCustomerFail(response));
  }
}
export function* watchSearchCustomerSaga() {
  yield takeEvery(SEARCH_CUSTOMER, searchCustomerSaga);
}

//GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES
export function* getCustomerBalanceHistoricalAvailableDatesSaga() {
  const response = yield call(
    getCustomerBalanceHistoricalAvailableDatesApiCall
  );
  if (response) {
    yield put(getCustomerBalanceHistoricalAvailableDatesSuccess(response));
  } else {
    yield put(getCustomerBalanceHistoricalAvailableDatesFail(response));
  }
}

export function* watchGetCustomerBalanceHistoricalAvailableDatesSaga() {
  yield takeEvery(
    GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES,
    getCustomerBalanceHistoricalAvailableDatesSaga
  );
}

//GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE
export function* getCustomerBalanceHistoricalSpecificDateSaga(action) {
  const response = yield call(
    getCustomerBalanceHistoricalSpecificDateApiCall,
    action.payload
  );
  if (response) {
    yield put(getCustomerBalanceHistoricalSpecificDateSuccess(response));
  } else {
    yield put(getCustomerBalanceHistoricalSpecificDateFail(response));
  }
}

export function* watchGetCustomerBalanceHistoricalSpecificDateSaga() {
  yield takeEvery(
    GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE,
    getCustomerBalanceHistoricalSpecificDateSaga
  );
}

//GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER
export function* getCustomerBalanceHistoricalByCustomerSaga(action) {
  const response = yield call(
    getCustomerBalanceHistoricalByCustomerApiCall,
    action.payload
  );
  if (response) {
    yield put(getCustomerBalanceHistoricalByCustomerSuccess(response));
  } else {
    yield put(getCustomerBalanceHistoricalByCustomerFail(response));
  }
}

export function* watchGetCustomerBalanceHistoricalByCustomerSaga() {
  yield takeEvery(
    GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER,
    getCustomerBalanceHistoricalByCustomerSaga
  );
}

// Search Customer Note
export function* searchCustomerNoteSaga(action) {
  const response = yield call(searchCustomerNoteApiCall, action.payload);
  if (response) {
    yield put(searchCustomerNoteSuccess(response));
  } else {
    yield put(searchCustomerNoteFail(response));
  }
}

export function* watchSearchCustomerNoteSaga() {
  yield takeEvery(SEARCH_CUSTOMER_NOTE, searchCustomerNoteSaga);
}

// Create Customer Note
export function* createCustomerNoteSaga(action) {
  const response = yield call(createCustomerNoteApiCall, action.payload);
  if (response) {
    yield put(createCustomerNoteSuccess(response));
  } else {
    yield put(createCustomerNoteFail(response));
  }
}

export function* watchCreateCustomerNoteSaga() {
  yield takeEvery(CREATE_CUSTOMER_NOTE, createCustomerNoteSaga);
}

// function main saga
export default function* CustomersSaga() {
  yield all([
    fork(watchGetCustomersListDataSaga),
    fork(watchGetSingleCustomersDataSaga),
    fork(watchAddSingleNewCustomerSaga),
    fork(watchUpdateSingleCustomerSaga),
    fork(watchDeleteSingleCustomerSaga),
    fork(watchCreateNewSingleCustomerSaga),
    fork(watchGetSingleCustomerActivitiesListDataSaga),
    fork(watchSearchSingleCustomerURLLinkListDataSaga),
    fork(watchSearchSingleCustomerExternalIDsListDataSaga),
    fork(watchGetSingleCustomerSiteLocationListDataSaga),
    fork(watchGetSingleCustomerSiteLocationDataSaga),
    fork(watchAddNewSingleCustomerSiteLocationSaga),
    fork(watchUpdateSingleCustomerSiteLocationSaga),
    fork(watchDeleteSingleCustomerSiteLocationSaga),
    fork(watchGetSingleCustomerURLLinkDetailsSaga),
    fork(watchCreateSingleCustomerURLLinkSaga),
    fork(watchUpdateSingleCustomerURLLinkSaga),
    fork(watchDeleteSingleCustomerURLLinkSaga),
    fork(watchGetCustomerURLLinkStatusListDataSaga),
    fork(watchGetCustomerURLLinkStatusDetailsSaga),
    fork(watchCreateCustomerURLLinkStatusSaga),
    fork(watchUpdateCustomerURLLinkStatusSaga),
    fork(watchDeleteCustomerURLLinkStatusSaga),
    fork(watchGetCustomerURLLinkTypeListDataSaga),
    fork(watchGetCustomerURLLinkTypeDetailsSaga),
    fork(watchCreateCustomerURLLinkTypeSaga),
    fork(watchUpdateCustomerURLLinkTypeSaga),
    fork(watchDeleteCustomerURLLinkTypeSaga),
    fork(watchGetCustomersDebitBalanceListDataSaga),
    fork(watchGetCustomersOverdueBalanceListDataSaga),
    fork(watchGetCustomersBalanceListAllDataSaga),
    fork(watchClearCustomerTransactionsListSaga),
    fork(watchGetSingleCustomerExternalIDsDetailsSaga),
    fork(watchCreateSingleCustomerExternalIDsSaga),
    fork(watchUpdateSingleCustomerExternalIDsSaga),
    fork(watchDeleteSingleCustomerExternalIDsSaga),
    fork(
      watchGetSingleCustomerExternalIDsExternalIdentificationProviderListDataSaga
    ),
    fork(
      watchGetSingleCustomerExternalIDsExternalIdentificationProviderDetailsSaga
    ),
    fork(
      watchCreateSingleCustomerExternalIDsExternalIdentificationProviderSaga
    ),
    fork(
      watchUpdateSingleCustomerExternalIDsExternalIdentificationProviderSaga
    ),
    fork(
      watchDeleteSingleCustomerExternalIDsExternalIdentificationProviderSaga
    ),
    fork(watchGetCustomerStatusListDataSaga),
    fork(watchGetCustomerStatusDetailsSaga),
    fork(watchCreateCustomerStatusSaga),
    fork(watchUpdateCustomerStatusSaga),
    fork(watchDeleteCustomerStatusSaga),
    fork(watchGetCustomerTypeListDataSaga),
    fork(watchGetCustomerTypeDetailsSaga),
    fork(watchCreateCustomerTypeSaga),
    fork(watchUpdateCustomerTypeSaga),
    fork(watchDeleteCustomerTypeSaga),
    fork(watchExportContactsSaga),
    fork(watchSearchCustomerSaga),
    fork(watchGetCustomerBalanceHistoricalAvailableDatesSaga),
    fork(watchGetCustomerBalanceHistoricalSpecificDateSaga),
    fork(watchGetCustomerBalanceHistoricalByCustomerSaga),
    fork(watchSearchCustomerNoteSaga),
    fork(watchCreateCustomerNoteSaga),
  ]);
}
